import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DoneIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Cancel';
import { DataGrid, GridRenderCellParams } from '@mui/x-data-grid';
import theme from '../theme';
import { InventoryUploadResponse } from '../hooks/useUploadInventory';

interface ImportSensorsModalProps {
  open: boolean;
  onClose: () => void;
  uploadResponse: InventoryUploadResponse | null;
}

const columns = [
  {
    field: 'sensorId',
    headerName: 'Sensor ID',
    flex: 1,
    minWidth: 160,
    headerClassName: 'bold-header',
  },
  {
    field: 'message',
    headerName: 'Message',
    flex: 2,
    minWidth: 260,
    headerClassName: 'bold-header',
  },
  {
    field: 'isProcessed',
    headerName: 'Processed',
    width: 120,
    align: 'center' as const,
    headerAlign: 'center' as const,
    renderCell: ({ value }: GridRenderCellParams) => (
      value
        ? <DoneIcon sx={{ color: theme.palette.success.main, marginTop: 0.75 }} />
        : <CancelIcon sx={{ color: theme.palette.error.main, marginTop: 0.75 }} />
    ),
    headerClassName: 'bold-header',
  },
];

const ImportSensorsModal = ({ open, onClose, uploadResponse }: ImportSensorsModalProps) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
      <DialogTitle>Import Sensors</DialogTitle>
      <DialogContent>
        {uploadResponse && (
          <>
            <div style={{ marginBottom: 16 }}>
              <span style={{ color: theme.palette.success.main, marginRight: 16 }}>
                Processed: {uploadResponse.processed}
              </span>
              <span style={{ color: uploadResponse.failed ? theme.palette.error.main : theme.palette.success.main }}>
                Failed: {uploadResponse.failed}
              </span>
            </div>
            <DataGrid
              autoHeight
              rows={uploadResponse.results}
              columns={columns}
              getRowId={(row) => row.sensorId}
              pageSizeOptions={[5, 10, 25]}
              initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
              disableRowSelectionOnClick
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImportSensorsModal;
